import React from "react";
import BaseListPage from "../../base/BaseListPage";
import withRouter from "../../withRouter";
import SaleTransPresenter from "./SaleTransPresenter";
import { countObjectUseCase, findObjectUseCase } from "../../usecases/object";
import NavBar from "../../components/navbar";
import schemaDashboard from "./schemaDashboard.json";
import Count from "../dashboard/components/Count";
import DateRangeReport from "../../components/DateRangeReport";
import RightSidebarFilter from "../../components/RightSidebarFilter";
import MonthlySalesChartPage from "./chart/monthlyChart/MonthlySalesChartPage";
import ShareSalesContribution from "./chart/shareSalesContribution/ShareSalesContribution";
import LoadingState from "../../components/LoadingState";
import InitialPrompt from "../../components/InitialPrompt";
import TargetHit from "./chart/targetHit/TargetHit";
import Select from "react-select";
import "./Style.css";
import ProgressLoader from "../../components/ProgressLoader";

class SaleTransPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new SaleTransPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase()
    );
    this.state = {
      objects: [],
      objects2: [],
      selected: [],
      progress: true,
      count: 0,
      count2: 0,
      where: {},
      range: "",
      store: [],
      storess: "",
      storess2: "",
      showMobileFilters: false,
      notFound: false,
    };
  }

  getCollectionName() {
    return "transactions";
  }

  setStore(store) {
    this.setState({ store });
  }

  setCount2(count2) {
    this.setState({ count2 });
  }

  onChangeStore(where) {
    this.setState({ storess: where, showMobileFilters: false });
    this.presenter.onChangeStore(where);
  }

  onChangeStore2(where) {
    this.presenter.onChangeStore2(where);
    this.setState({ storess2: where });
  }

  onChangeDate(where) {
    this.presenter.onChangeDate(where);
    this.setState({ range: where });
  }
  onChangeDate2(where) {
    const gteDate = new Date(where["$gte"]);
    const lteDate = new Date(where["$lte"]);

    gteDate.setUTCHours(5, 0, 0, 0);
    lteDate.setUTCDate(lteDate.getUTCDate() + 1);
    lteDate.setUTCHours(4, 59, 59, 999);

    where["$gte"] = gteDate.toISOString();
    where["$lte"] = lteDate.toISOString();

    this.presenter.onChangeDate2(where);
  }

  getValueForDashboardObject(object) {
    switch (object.label) {
      case "Gross Sales":
        return this.presenter.calculateGrossSalesInfo();
      case "Total Transaction":
        return this.presenter.calculateTotalTransactionInfo();
      case "Total Guest":
        return this.presenter.calculateTotalGuestInfo();
      case "Discount Cost":
        return this.presenter.calculateDiscountCost();
      case "Total Tax Free":
        return this.presenter.calculateTotalTaxFree();
      default:
        return { value: 0, percentage: 0 };
    }
  }

  handleCountClick(nav) {
    this.navigateTo(nav);
  }

  setObjects2(objects2) {
    this.setState({ objects2: objects2 });
  }

  getProgressPercentage() {
    const { objects, count } = this.state;
    if (!count || count === 0) return 0;
    return Math.min(Math.round((objects.length / count) * 100), 100);
  }

  getProgressPercentage2() {
    const { objects2, count2 } = this.state;
    if (!count2 || count2 === 0) return 0;
    return Math.min(Math.round((objects2.length / count2) * 100), 100);
  }

  setNotFound(not) {
    this.setState({ notFound: not });
  }

  setNotFound2(not) {
    this.setState({ notFound: not });
  }

  render() {
    const objects = this.state.objects;
    const objects2 = this.state.objects2;
    const store = this.state.store;
    const renderBox = objects?.length > 0;

    return (
      <>
        <NavBar />
        <RightSidebarFilter
          isVisible={this.state.showMobileFilters}
          onClose={() => this.setState({ showMobileFilters: false })}
          onDateChange={this.onChangeDate.bind(this)}
          onStoreChange={(store) =>
            this.setState({ storess: store, showMobileFilters: false }, () =>
              this.presenter.onChangeStore(store)
            )
          }
          storeList={this.state.store}
          range={this.state.range}
        />

        <div className="overflow-auto">
          <div className="p-3 p-lg-4">
            <div className="d-flex justify-content-between align-items-center mt-2 px-1">
              <h1
                className="fw-bold mt-3 text-capitalize"
                style={{ color: "#83c14a" }}
              >
                Sales and Transaction
              </h1>

              <i
                className="bi bi-filter d-md-none fs-1"
                onClick={() => this.setState({ showMobileFilters: true })}
                style={{ color: "#83c14a" }}
              ></i>
            </div>

            <div className="row mb-2 d-none d-md-flex">
              <div className="col-md-4">
                <DateRangeReport
                  onChange={this.onChangeDate.bind(this)}
                  field="tran_date"
                />
              </div>

              <div className="col-md-4">
                <Select
                  options={this.state.store
                    .map((code) => ({
                      value: code.name,
                      label: code.name.replace(/_/g, " "),
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label))}
                  onChange={(selected) => this.onChangeStore(selected.value)}
                  isDisabled={!this.state.range}
                  placeholder="Select Store"
                  className="basic-single"
                  classNamePrefix="select"
                />
              </div>
            </div>

            <ProgressLoader
              loaded={this.state.objects.length}
              total={this.state.count}
              getProgressPercentage={() => this.getProgressPercentage()}
            />

            {/* {renderBox ? (
              <div className="row mt-1 g-3">
                {schemaDashboard.map((object, index) => {
                  const { value, percentage } = this.getValueForDashboardObject(
                    object,
                    objects
                  );

                  const navigationTarget = object.navigationTarget;
                  return (
                    <div key={index} className="col-6 col-md-3">
                      <Count
                        collection={object.collection}
                        icon={object.icon}
                        where={object.where}
                        val={value}
                        label={object.label}
                        labelAction={object.labelAction}
                        barangayValue={this.state.barangayValue}
                        object={object}
                        percentage={percentage}
                        bg={object.bg}
                        onClick={() => this.handleCountClick(navigationTarget)}
                      />
                    </div>
                  );
                })}
              </div>
            ) : this.state.range && this.state.storess ? (
              <div className="text-center mt-5">
                <LoadingState />
              </div>
            ) : (
              <InitialPrompt twoFilter={true} />
            )} */}

            {renderBox ? (
              <div className="row mt-1 g-3">
                {schemaDashboard.map((object, index) => {
                  const { value, percentage } = this.getValueForDashboardObject(
                    object,
                    objects
                  );
                  const navigationTarget = object.navigationTarget;

                  return (
                    <div key={index} className="col-6 col-md-3">
                      <Count
                        collection={object.collection}
                        icon={object.icon}
                        where={object.where}
                        val={value}
                        label={object.label}
                        labelAction={object.labelAction}
                        barangayValue={this.state.barangayValue}
                        object={object}
                        percentage={percentage}
                        bg={object.bg}
                        onClick={() => this.handleCountClick(navigationTarget)}
                      />
                    </div>
                  );
                })}
              </div>
            ) : this.state.range && this.state.storess ? (
              this.state.notFound ? (
                <div className="text-center mt-5">
                  <p className="text-muted fs-5">
                    📭 Data not found for selected filter.
                  </p>
                </div>
              ) : (
                <div className="text-center mt-5">
                  <LoadingState />
                </div>
              )
            ) : (
              <InitialPrompt twoFilter={true} />
            )}

            <div className="mt-5">
              <ShareSalesContribution
                objects={objects}
                storess={this.state.storess}
              />
            </div>

            <div className="mt-5">
              <ProgressLoader
                loaded={this.state.objects2.length}
                total={this.state.count2}
                getProgressPercentage={() => this.getProgressPercentage2()}
              />
              <MonthlySalesChartPage
                objects={objects2}
                onChangeDate={this.onChangeDate2.bind(this)}
                onChangeStore={this.onChangeStore2.bind(this)}
                dateField="createdAt"
                store={store}
                storess={this.state.storess2}
                progress={this.presenter.progress}
              />
            </div>

            <div className="mt-4">
              <TargetHit
                objects={objects2}
                storess={this.state.storess2}
                store={store}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(SaleTransPage);
